module.exports = __webpack_public_path__ + "assets/img/Account Holder@2x.da02bce3.png";